var _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconGoldTick = function SvgIconGoldTick(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5BD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A5721A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    d: "M0 0.154H25V25.154H0z",
    transform: "translate(-1 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "nonzero",
    d: "M21.39 5.462L9.095 17.561l-6.105-5.5c-.308-.29-.752-.394-1.16-.27-.407.123-.715.454-.804.865-.09.41.055.836.375 1.112l6.935 6.25c.464.42 1.181.404 1.627-.034L23.055 7.101c.46-.452.46-1.186 0-1.639-.46-.452-1.205-.452-1.665 0z",
    transform: "translate(-1 -5)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGoldTick, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDIzIDE2Ij4KICAgIDxkZWZzPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icHJlZml4X19hIiB4MT0iMTAwJSIgeDI9IjAlIiB5MT0iNTAlIiB5Mj0iNTAlIj4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI0Y1QkQ1NiIvPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiNBNTcyMUEiLz4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLW9wYWNpdHk9IjAiIGQ9Ik0wIDAuMTU0SDI1VjI1LjE1NEgweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTUpIi8+CiAgICAgICAgPHBhdGggZmlsbD0idXJsKCNwcmVmaXhfX2EpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0yMS4zOSA1LjQ2Mkw5LjA5NSAxNy41NjFsLTYuMTA1LTUuNWMtLjMwOC0uMjktLjc1Mi0uMzk0LTEuMTYtLjI3LS40MDcuMTIzLS43MTUuNDU0LS44MDQuODY1LS4wOS40MS4wNTUuODM2LjM3NSAxLjExMmw2LjkzNSA2LjI1Yy40NjQuNDIgMS4xODEuNDA0IDEuNjI3LS4wMzRMMjMuMDU1IDcuMTAxYy40Ni0uNDUyLjQ2LTEuMTg2IDAtMS42MzktLjQ2LS40NTItMS4yMDUtLjQ1Mi0xLjY2NSAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTUpIi8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };